import { render, staticRenderFns } from "./ScheduleSetting.vue?vue&type=template&id=b8224060&scoped=true&"
import script from "./ScheduleSetting.vue?vue&type=script&lang=js&"
export * from "./ScheduleSetting.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleSetting.vue?vue&type=style&index=0&id=b8224060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8224060",
  null
  
)

export default component.exports